import { ChunkLoadRecoveryService } from '@ag2-weathermaker/core/services/chunk-load-recovery/chunk-load-recovery.service';
import { ErrorHandler, inject, Injectable, Injector } from '@angular/core';
import * as Sentry from '@sentry/angular';

/**
 * Wraps the Sentry error handler so a stale lazy-chunk failure that surfaces
 * here (not via the router's navigation-error handler) still triggers recovery. \
 * All errors continue to flow to Sentry for telemetry.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly injector = inject(Injector);
  private readonly delegate = Sentry.createErrorHandler();

  handleError(error: unknown): void {
    try {
      this.injector.get(ChunkLoadRecoveryService).handleError(error);
    } finally {
      this.delegate.handleError(error);
    }
  }
}
